import axios from "axios";

const baseApiUrl =
  process.env.REACT_APP_API_LOGIN_URL ||
  "https://api-dev-scoringcapture.lanetalk.com/v1";

const instance = axios.create({
  baseURL: `${baseApiUrl}/users`,
});

const getUsers = ({ access_token }, page) => {
  const params = { page };

  return instance
    .get(``, {
      headers: { Authorization: `Bearer ${access_token}` },
      params: params,
    })
    .then(({ data }) => data)
    .catch((e) => {
      return { success: false, message: e.response?.data?.error };
    });
};

const createUser = ({ access_token }, values) => {
  return instance
    .post(``, values, { headers: { Authorization: `Bearer ${access_token}` } })
    .then((res) => {
      if (res.status === 200) console.log("Account created");
      return res.data;
    })
    .catch((e) => {
      console.log(e.response?.data?.message || e.message);
      if (e.response?.data?.errors?.email) {
        return { success: false, emailError: true };
      }
      return {
        success: false,
        message: e.response?.data?.error || e.message,
      };
    });
};
const updateUser = ({ access_token }, values, id) => {
  return instance
    .put(`/${id}`, values, {
      headers: { Authorization: `Bearer ${access_token}` },
    })
    .then((res) => {
      if (res.status === 200) console.log("Account updated");
      return res.data;
    })
    .catch((e) => {
      console.log(e.response?.data?.message || e.message);
      if (e.response?.data?.errors?.email) {
        return { success: false, emailError: true };
      }
      return {
        success: false,
        message: e.response?.data?.error || e.message,
      };
    });
};

const changePassword = ({ access_token }, values, id) => {
  const inst = axios.create({
    baseURL: `${baseApiUrl}`,
  });
  return inst
    .post(`/auth/change-password`, values, {
      headers: { Authorization: `Bearer ${access_token}` },
    })
    .then((res) => {
      return res.data;
    })
    .catch((e) => {
      if (e.response?.data?.errors?.email) {
        return { success: false, emailError: true };
      }
      return {
        success: false,
        message: e.response?.data?.error || e.message,
      };
    });
};

const deleteUser = ({ access_token }, id) => {
  return instance
    .delete(`/${id}`, { headers: { Authorization: `Bearer ${access_token}` } })
    .then((res) => {
      if (res.status === 200) console.log("Account deleted");
      return res.data;
    })
    .catch((e) => console.log(e.response?.data?.message || e.message));
};

const getUserProfile = ({ access_token }, id) => {
  return instance
    .get(`/${id}/profile`, {
      headers: { Authorization: `Bearer ${access_token}` },
    })
    .then((res) => {
      return res.data;
    })
    .catch((e) => console.log(e.response?.data?.message || e.message));
};

const sendVerificationCode = ({ access_token }, id) => {
  return instance
    .post(`/${id}/resend-verification`, null, {
      headers: { Authorization: `Bearer ${access_token}` },
    })
    .then((res) => {
      return res.data;
    })
    .catch((e) => console.log(e.response?.data?.message || e.message));
};

export {
  getUsers,
  createUser,
  updateUser,
  deleteUser,
  getUserProfile,
  sendVerificationCode,
  changePassword,
};
